import React from "react";
import {DetailsList, SelectionMode} from "@fluentui/react";

import type IsaacToastProps from "./IsaacTableProps";

// Note: Component meant to replace legacy Table
const IsaacTable = <T,>({
  items,
  columns,
  className,
  selectionMode,
  onRenderField,
  onRenderHeader,
  onRenderItemColumn,
}: IsaacToastProps<T>): JSX.Element => {
  return (
    <DetailsList
      items={items ?? []}
      selectionMode={selectionMode ?? SelectionMode.none}
      columns={columns}
      className={className}
      onRenderDetailsHeader={onRenderHeader}
      onRenderField={onRenderField}
      onRenderItemColumn={onRenderItemColumn}
    />
  );
};

export default IsaacTable;
